import { render, staticRenderFns } from "./JobModule.vue?vue&type=template&id=674f1faa&scoped=true&"
import script from "./JobModule.vue?vue&type=script&lang=js&"
export * from "./JobModule.vue?vue&type=script&lang=js&"
import style0 from "./JobModule.vue?vue&type=style&index=0&id=674f1faa&scoped=true&lang=css&"
import style1 from "./JobModule.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f1faa",
  null
  
)

export default component.exports